import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\TransportPriceController::index
* @see app/Http/Controllers/Admin/TransportPriceController.php:21
* @route '/admin/transport-prices'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/transport-prices',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\TransportPriceController::index
* @see app/Http/Controllers/Admin/TransportPriceController.php:21
* @route '/admin/transport-prices'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\TransportPriceController::index
* @see app/Http/Controllers/Admin/TransportPriceController.php:21
* @route '/admin/transport-prices'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\TransportPriceController::index
* @see app/Http/Controllers/Admin/TransportPriceController.php:21
* @route '/admin/transport-prices'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\TransportPriceController::store
* @see app/Http/Controllers/Admin/TransportPriceController.php:48
* @route '/admin/transport-prices'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/admin/transport-prices',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\TransportPriceController::store
* @see app/Http/Controllers/Admin/TransportPriceController.php:48
* @route '/admin/transport-prices'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\TransportPriceController::store
* @see app/Http/Controllers/Admin/TransportPriceController.php:48
* @route '/admin/transport-prices'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\TransportPriceController::update
* @see app/Http/Controllers/Admin/TransportPriceController.php:113
* @route '/admin/transport-prices/{transportPrice}'
*/
export const update = (args: { transportPrice: number | { id: number } } | [transportPrice: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/admin/transport-prices/{transportPrice}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\TransportPriceController::update
* @see app/Http/Controllers/Admin/TransportPriceController.php:113
* @route '/admin/transport-prices/{transportPrice}'
*/
update.url = (args: { transportPrice: number | { id: number } } | [transportPrice: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { transportPrice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { transportPrice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            transportPrice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        transportPrice: typeof args.transportPrice === 'object'
        ? args.transportPrice.id
        : args.transportPrice,
    }

    return update.definition.url
            .replace('{transportPrice}', parsedArgs.transportPrice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\TransportPriceController::update
* @see app/Http/Controllers/Admin/TransportPriceController.php:113
* @route '/admin/transport-prices/{transportPrice}'
*/
update.put = (args: { transportPrice: number | { id: number } } | [transportPrice: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

const transportPrices = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    update: Object.assign(update, update),
}

export default transportPrices